import { render } from "./Loading.vue?vue&type=template&id=2b45d7ae"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"
script.render = render

export default script